export const GET_CURRENCY = "GET_CURRENCY";
export const CREATE_NEW_CURRENCY = "CREATE_NEW_CURRENCY";
export const UPDATE_CURRENCY = "UPDATE_CURRENCY";
export const DELETE_CURRENCY = "DELETE_CURRENCY";
export const UPDATE_CURRENCY_STATUS = "UPDATE_CURRENCY_STATUS";
export const OPEN_CURRENCY_DIALOG = "OPEN_CURRENCY_DIALOG";
export const CLOSE_CURRENCY_DIALOG = "CLOSE_CURRENCY_DIALOG";